import { emitAddToBasketEvent } from "./emitter.js";

const addToBasket = (variationId, additionalWidgetClickTracking, additionalProductClickTracking) => {
    const promoAttributionFeatureValue = additionalWidgetClickTracking["wk.promo_AttributionFeature"][0];

    const event = {
        variationId: variationId,
        quantity: 1,
        itemOrigin: "addToBasketConfirmation_RecoComplementary",
        tracking: Object.entries({
            ...additionalWidgetClickTracking,
            ...additionalProductClickTracking,
            "wk.promo_AttributionFeature": [promoAttributionFeatureValue],
        }).reduce((acc, [key, value]) => {
            return {
                ...acc,
                [key]: value[0],
            };
        }, {}),
    };

    emitAddToBasketEvent(event);
};

export default addToBasket;
